<template>
	<div class="page-main">
		<div class="main-head">
			<div class="breakcrumbs">新闻动态 > 详情</div>
			<div class="back-btn">返回</div>
		</div>
		<div class="detail-ctn" v-if="detail">
			<h3 class="title">{{detail.contentTitle}}</h3>
			<div class="date">{{detail.createdDt}}</div>
			<div class="ctn" v-html="detail.contentDesc">
				<!-- <p>文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容</p>
				<p>文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容</p>
				<p>文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容</p>
				<p>文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容</p>
				<p>文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容</p>
				<p>文章内容文章内容文章内容文章内容文章内容文章内容文章内容文章内容</p> -->
			</div>
		</div>
		<van-empty v-if="!detail"  description="没找到相应内容" />
	</div>
</template>

<script>
import msecond from '@/components/second.vue'
export default {
	name: 'newsDetail',
	components:{
		msecond
	},
	data () {
		return {
			firstColumnId:'',	//一级栏目id
			secondColumnId:'',	//二级栏目id
			secondInfo:{
				title:'',
				list:[
					// { title:'新闻动态',  },
					// { title:'政策文件',  }
				],
				columnId:''
			},
			detail:null
		}
	},
	
	async created(){
		await this.$onLaunched;		//监听加载了APP.vue中的onLaunched的异步后执行
		const { id } = this.$route.params
		this.getDetail(id)
	},
  
	computed:{
		navList(){
			return this.$store.state.navList
		}
	},
	
	watch:{
		navList(val){
			if(val){
				// this.getSecondColumnList()
			}
		}
	},
  
	methods:{
		//获取一级栏目名称
		getColumnTitle(){
			const { navList } = this.$store.state
			let parentName = ''
			navList.forEach(item=>{
				if(item.columnId == this.firstColumnId){
					parentName = item.columnName
				}
			})
			this.secondInfo.title = parentName
			this.$store.commit('changeNavId',this.firstColumnId)
		},
		
		//查询二级栏目
		getSecondColumnList(){
			this.$axios({
				url:`/jxedu/api/site/secondColumnList/${this.firstColumnId}`,
			}).then(res=>{
				let list = res.data
				let infoList = []
				list.forEach((item,index)=>{
					infoList.push({
						title:item.columnName,
						columnId:item.columnId
					})
				})
				this.secondInfo.list = infoList
				//const { parentId } = this.$route.query
				this.secondInfo.columnId = this.secondColumnId
			})
		},
		
		//获取新闻详情
		getDetail(contentId){
			this.$axios({
				url:`/jxedu/api/site/findById/${contentId}`,
			}).then(res=>{
				let detail = res.data
				this.detail = detail
				this.firstColumnId = detail.parentId
				this.secondColumnId = detail.columnId
				this.getColumnTitle()
				this.getSecondColumnList()
			})
		},
		
		//改变左侧菜单栏
		changeNav(columnId){
			this.goUrl({name:'news', params:{ firstCateId: this.firstColumnId }, query:{ secondCateId : columnId }})
		},
		
		
	}
}
</script>

<style lang="less" scoped>
// .page-mdl{ 
// 	width:1200px; margin:30px auto; background:#fff; box-shadow: 0px 0px 18px 0px rgba(29,124,224,0.0900); border-radius: 4px;
// 	.detail-head{
// 		border-bottom:1px solid #D8DADD; height:54px; position:relative;
// 		padding:0 24px; display:flex; justify-content: space-between; align-items: center;
// 		&::before{
// 			content:''; display:inline-block; width: 7px; height: 40px; background: #2E75EB; border-radius:0 7px 7px 0;
// 			position:absolute; left:0; top:50%; margin-top:-20px;
// 		}
// 		.breakcrumbs{ color:#A3A8AF; font-size:14px; }
// 		.back-btn{ 
// 			display:inline-block; width: 110px; height: 32px; line-height:32px; background: #2E75EB; cursor: pointer;
// 			box-shadow: 0px 4px 8px 0px #E7EEFA; border-radius: 16px; text-align: center; color:#fff; font-size:14px;
// 			&:hover{ opacity: .9; text-decoration: none; }
// 		}
// 	}
// }
.detail-ctn{
	font-size:16px; color:#333; line-height:24px; padding:48px 180px 48px;
	.title{ font-size:24px; line-height:36px; color:#333333; text-align:center; font-weight: bold; }
	.date{ font-size:14px; color:#A3A8AF; text-align:center; margin-bottom:60px; margin-top:18px;}
	p{ margin-bottom:20px; }
	/deep/ img{ max-width:100%;}
}
</style>



// WEBPACK FOOTER //
// src/pages/news-detail/tpl-pc.vue